import { useMemo } from 'react';
import { useLocationContext } from './useLocationContext';
export const useTranslations = () => {
    const { translations } = useLocationContext();
    return useMemo(() => ({
        t: (id) => {
            const value = (translations || {})[id || ''];
            if (!value) {
                return id;
            }
            return value;
        },
    }), [translations]);
};
//# sourceMappingURL=useTranslations.js.map